<template>
  <div class="headerBlock" :style="headerBlockStyle">
    <div class="text-panel">
      <span>{{title}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "header-block",
  props: {
    width: {
      default: "100%"
    },
    height: {
      default: "30px"
    },
    position: {
      default: "center" // left center right
    },
    textStyle: {
      default() {
        return {
          color: "white"
        };
      }
    },
    title: {
      default: "活跃用户数"
    }
  },
  computed: {
    headerBlockStyle() {
      return {
        width: this.width,
        height: this.height,
        lineHeight: this.height,
        textAlign: this.position
      };
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style scoped lang='scss'>
.headerBlock {

}
</style>